{
	"title": "Карточки",
	"subtitle": "{sets, plural, one {# набор} few {# набора} many {# наборов} other {# набора}} · {total, plural, one {# карточка} few {# карточки} many {# карточек} other {# карточки}} · {due} на сегодня",
	"generate": {
		"cta": "Сгенерировать",
		"title": "Сгенерировать карточки",
		"description": "Из материала через AI. Результаты можно отредактировать.",
		"source": "Источник",
		"sourceMaterial": "Из материала",
		"sourceTopic": "Стандалон по теме",
		"materialPicker": "Материал",
		"materialPlaceholder": "Выбери материал...",
		"topicLabel": "Тема",
		"topicPlaceholder": "Цикл Кребса. Связь с аэробным гликолизом...",
		"nameLabel": "Название набора (опц.)",
		"namePlaceholder": "Авто-заполнение из материала",
		"typesLabel": "Типы карточек",
		"countLabel": "Количество карточек",
		"languageLabel": "Язык генерации",
		"languageHint": "Учитываем язык исходного материала и твой UI-язык",
		"submit": "Сгенерировать",
		"cancel": "Отмена",
		"quotaTitle": "AI-генерация карточек",
		"quotaUsage": "{used} из {limit} в этом месяце",
		"quotaReset": "Сброс {date}",
		"quotaUpsell": "Узнать про Plus",
		"streamingTitle": "Создаём набор...",
		"streamingStage": "Этап: {stage}",
		"streamingProgress": "Готовы {done} из {total}",
		"closeAndKeep": "Закрыть и продолжить в фоне",
		"openSet": "Открыть набор",
		"successTitle": "Готово! Сгенерировано {count, plural, one {# карточка} few {# карточки} many {# карточек} other {# карточки}}",
		"createAnother": "Создать ещё",
		"hintAudio": "Audio-term: TTS-генерация добавляет ~30 сек",
		"hintImage": "Image-term: распознавание изображений из материала",
		"materialLoading": "Загрузка…",
		"materialPagesShort": "{count} стр",
		"materialMinutesShort": "{count} мин"
	},
	"library": {
		"newSet": "Создать",
		"setCta": "Создать пустой",
		"createSet": "Создать пустой",
		"createSetTitle": "Создать пустой",
		"setNamePlaceholder": "ЕГЭ Биология",
		"colorLabel": "Цвет",
		"colorPickerAria": "Цвет {color}",
		"kpi": {
			"due": "сегодня",
			"new": "новые",
			"total": "освоено",
			"accuracy": "точность"
		},
		"filters": {
			"material": "По материалу",
			"tag": "Тег",
			"sort": "Сортировка",
			"sortUpdated": "По дате",
			"sortDue": "По сроку",
			"sortAccuracy": "По точности",
			"view": "Вид",
			"viewGrid": "Сетка",
			"viewTable": "Таблица",
			"search": "Поиск по наборам...",
			"searchBookmarks": "Поиск по закладкам..."
		},
		"searchEmpty": {
			"title": "Ничего не найдено",
			"subtitle": "По запросу «{query}» наборов нет. Измените запрос или фильтр."
		},
		"card": {
			"cardCount": "{count, plural, one {# карточка} few {# карточки} many {# карточек} other {# карточки}}",
			"dueToday": "на сегодня",
			"noDue": "Нет на сегодня",
			"studyCta": "Учить",
			"continueCta": "Продолжить",
			"mastered": "{pct}% освоено",
			"fromMaterial": "Из материала «{name}»",
			"fromChat": "Из чата «{name}»"
		},
		"empty": {
			"title": "У тебя пока нет наборов карточек.",
			"subtitle": "Сгенерируй из материала или создай вручную.",
			"generate": "Сгенерировать из материала",
			"create": "Создать пустой"
		},
		"markedPreview": {
			"title": "Закладки",
			"openAll": "Открыть все",
			"emptyHint": "Здесь будут карточки, которые ты добавишь в закладки во время сессии."
		},
		"tabs": {
			"aria": "Наборы или закладки",
			"sets": "Наборы",
			"bookmarks": "Закладки"
		},
		"bookmarks": {
			"count": "{total, plural, one {# карточка в закладках} few {# карточки в закладках} many {# карточек в закладках} other {# карточки в закладках}}",
			"studyAll": "Учить все ({n})",
			"manage": "Все закладки",
			"emptyTitle": "В закладках пока пусто.",
			"emptyHint": "Во время сессии повторения нажми на закладку или клавишу M — карточка попадёт сюда.",
			"searchEmptyTitle": "Ничего не найдено",
			"searchEmptyHint": "По этому запросу в закладках карточек нет. Измените поиск или сбросьте фильтр."
		},
		"streaming": {
			"label": "Генерируем...",
			"stage": "Этап: {stage}",
			"failed": "Не удалось сгенерировать",
			"retry": "Повторить"
		},
		"menu": {
			"title": "Действия",
			"rename": "Переименовать",
			"color": "Изменить цвет",
			"delete": "Удалить",
			"export": "Экспорт CSV",
			"editCards": "Редактировать"
		},
		"renameDialog": {
			"title": "Переименовать набор",
			"placeholder": "Название набора",
			"submit": "Сохранить",
			"success": "Набор переименован",
			"error": "Не удалось переименовать"
		},
		"colorDialog": {
			"title": "Изменить цвет",
			"submit": "Сохранить",
			"success": "Цвет обновлён"
		},
		"deleteDialog": {
			"title": "Удалить набор «{name}»?",
			"description": "Набор и карточки попадут в корзину на 30 дней.",
			"submit": "В корзину",
			"cancel": "Отмена",
			"success": "Набор перемещён в корзину",
			"error": "Не удалось удалить"
		},
		"relativeTime": {
			"minutesAgo": "{count, plural, one {# мин} few {# мин} many {# мин} other {# мин}} назад",
			"hoursAgo": "{count, plural, one {# ч} few {# ч} many {# ч} other {# ч}} назад",
			"daysAgo": "{count, plural, one {# д} few {# д} many {# д} other {# д}} назад",
			"justNow": "только что"
		},
		"stages": {
			"queued": "В очереди",
			"retrieving": "Поиск контекста",
			"generating": "Создаём карточки",
			"tts-batching": "Озвучка",
			"persisting": "Сохраняем",
			"done": "Готово"
		},
		"errorTitle": "Не удалось загрузить",
		"errorSubtitle": "Что-то пошло не так. Попробуй ещё раз.",
		"retry": "Повторить"
	},
	"setDetail": {
		"back": "Назад",
		"studyCta": "Учить {due}",
		"menu": {
			"rename": "Переименовать",
			"color": "Изменить цвет",
			"delete": "Удалить",
			"exportCsv": "Экспорт CSV",
			"regenerate": "Сгенерировать ещё",
			"openMaterial": "Открыть источник"
		},
		"subtitle": "{total, plural, one {# карточка} few {# карточки} many {# карточек} other {# карточки}} · {due} на сегодня · {new} новых · {mastery}% освоено",
		"stats": {
			"learned": "Освоено",
			"review": "Повторение",
			"new": "Новые",
			"marked": "В закладках",
			"averageEf": "Среднее EF: {ef}",
			"retention": "Долгосрочная память: {pct}%"
		},
		"toolbar": {
			"addCard": "Карточка",
			"generate": "Сгенерировать ещё",
			"reorder": "Изменить порядок",
			"import": "Импорт",
			"type": "Тип",
			"srs": "SRS",
			"marked": "Закладки",
			"search": "Поиск..."
		},
		"srsState": {
			"new": "Новые",
			"learning": "Изуч.",
			"review": "Повт.",
			"relearning": "Переуч.",
			"suspended": "Откл.",
			"buried": "Скрыт.",
			"all": "Все состояния"
		},
		"cardTypeLabel": {
			"all": "Все типы",
			"term-definition": "T-D",
			"fill-blank": "Пропуск",
			"multiple-choice": "MCQ",
			"audio-term": "Аудио",
			"image-term": "Img→T",
			"term-image": "T→Img"
		},
		"table": {
			"index": "#",
			"type": "Тип",
			"front": "Лицо/Вопрос",
			"back": "Оборот",
			"srs": "SRS",
			"actions": "Действия"
		},
		"empty": {
			"title": "В этом наборе пока нет карточек.",
			"subtitle": "Создай вручную, сгенерируй из материала или импортируй CSV."
		},
		"showMore": "Показать ещё {count} ↓",
		"deleteConfirm": {
			"title": "Удалить набор?",
			"body": "Набор «{name}» и все его карточки попадут в корзину на 30 дней."
		}
	},
	"study": {
		"title": "{setName} · режим {mode}",
		"counter": "{current} / {total}",
		"flipHint": "Нажми, чтобы перевернуть",
		"revealCta": "Показать ответ",
		"answerLabel": "Ответ",
		"sessionTitle": "Повторение карточек",
		"sessionSubtitle": "Сессия повторения",
		"cardKind": {
			"term-definition": "Термин и определение",
			"fill-blank": "Заполни пропуск",
			"multiple-choice": "Выбери ответ",
			"audio-term": "Аудио и термин",
			"image-term": "Картинка и термин",
			"term-image": "Термин и картинка"
		},
		"endSession": "Завершить сессию",
		"settings": "Настройки",
		"modes": {
			"srs": "SRS",
			"standard": "Стандартный",
			"cram": "Интенсив",
			"marked": "Закладки",
			"leitner-session": "Leitner"
		},
		"modeLabel": {
			"srs": "SRS (по расписанию)",
			"standard": "Стандартный (по порядку)",
			"cram": "Интенсив (все карты, повтор до Easy)",
			"marked": "Закладки (только закладки)",
			"leitner-session": "Leitner-сессия (1 проход)"
		},
		"interval": {
			"minutes": "{n}<10мин",
			"min": "<10 мин",
			"day": "{n, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
			"days": "{n} дней"
		},
		"intervals": {
			"again": "<10 мин",
			"hard": "1 день",
			"good": "3 дня",
			"easy": "7 дней"
		},
		"ratings": {
			"again": "Забыл",
			"hard": "С трудом",
			"good": "Помню",
			"easy": "Знаю"
		},
		"tour": {
			"openHelp": "Как это работает",
			"step1": {
				"title": "Это режим интервального повторения",
				"body": "Ты вспоминаешь ответ → честно оцениваешь себя → карточка возвращается через интервал. Чем легче — тем реже её увидишь."
			},
			"step2": {
				"title": "4 кнопки оценки",
				"body": "«Забыл» — увидишь через <10 мин. «С трудом» — через 1 день. «Помню» — через 3 дня. «Знаю» — через 7 дней. Интервал указан под каждой кнопкой."
			},
			"step3": {
				"title": "Главное — честность",
				"body": "Если поддашься соблазну ставить «Знаю» — алгоритм отложит карточку, и ты её забудешь. Оценивай, как реально вспомнил."
			},
			"next": "Дальше",
			"back": "Назад",
			"start": "Начать",
			"skip": "Пропустить"
		},
		"confidence": {
			"title": "Насколько уверен?",
			"sure": "Уверен",
			"unsure": "Не уверен",
			"guess": "Угадал"
		},
		"settingsSheet": {
			"title": "Настройки сессии",
			"modeLabel": "Режим сессии",
			"modeHint": {
				"srs": "Только карточки, у которых подошёл срок повторения по алгоритму.",
				"standard": "Все карточки набора подряд — без учёта SRS-расписания.",
				"cram": "Все карточки, плохо известные — повторяются до оценки «Знаю».",
				"marked": "Только карточки, добавленные в закладки.",
				"leitner-session": "Все карточки за один проход без повторов внутри сессии."
			},
			"orderLabel": "Порядок",
			"orderSequential": "По порядку",
			"orderRandom": "Случайный",
			"orderSpaced": "С интервалом",
			"orderHint": {
				"sequential": "Карточки идут в исходном порядке набора.",
				"random": "Колода перемешивается случайно перед стартом.",
				"spaced": "Карточки тасуются так, чтобы похожие/связанные шли не подряд."
			},
			"limitLabel": "Лимит карточек",
			"limitHint": "Сколько карточек показывать за одну сессию.",
			"confidenceLabel": "Оценка уверенности до ответа",
			"confidenceHint": "Перед показом ответа спросить, насколько ты уверен (для метакогнитивной обратной связи).",
			"audioSectionLabel": "Звук",
			"autoAudioLabel": "Автовоспроизведение озвучки",
			"autoAudioHint": "Автоматически проигрывать аудио карточки, когда она появляется на экране.",
			"sfxLabel": "Звуковые эффекты",
			"sfxHint": "Короткие звуки на действия: переворот, оценка, добавление в закладки.",
			"apply": "Сохранить и применить"
		},
		"endDialog": {
			"title": "Завершить сессию?",
			"subtitle": "У тебя есть {n} непросмотренных карточек.",
			"confirm": "Завершить сейчас",
			"cancel": "Продолжить"
		},
		"complete": {
			"title": "Сессия завершена",
			"cards": "Изучено карточек",
			"accuracy": "Точность",
			"marked": "В закладках",
			"duration": "Время",
			"nextDue": "Следующая на повторение",
			"perfect": "🎉 Идеальный результат!",
			"continueMarked": "Учить закладки",
			"backToSet": "В набор",
			"library": "В библиотеку"
		},
		"empty": {
			"title": "Всё освоено!",
			"subtitle": "На сегодня в этом наборе ничего нет.",
			"subtitleNext": "Вернись завтра — будут карточки на повторение.",
			"learnNew": "Учить новые",
			"openMarked": "Учить закладки",
			"backToSet": "← В набор",
			"toLibrary": "К наборам карточек"
		},
		"shortcuts": {
			"flip": "Перевернуть",
			"rate": "Оценить",
			"mark": "Закладка",
			"hint": "Подсказка",
			"source": "Источник",
			"undo": "Отменить",
			"skip": "Пропустить",
			"settings": "Настройки",
			"end": "Завершить",
			"navigate": "Листать"
		},
		"loading": "Готовим сессию...",
		"ratingQueued": "Без сети — сохраним позже",
		"audio": {
			"play": "Прослушать",
			"replay": "Повторить"
		},
		"mcq": {
			"correct": "Верный ответ",
			"youChose": "Ты выбрал"
		},
		"fillBlank": {
			"placeholder": "Введи ответ..."
		},
		"card": {
			"mark": "В закладки",
			"unmark": "Убрать из закладок",
			"source": "Источник",
			"hint": "Подсказка",
			"markFailed": "Не удалось обновить закладки"
		},
		"citationPageShort": "стр {page}"
	},
	"marked": {
		"title": "Закладки",
		"subtitle": "{total, plural, one {# карточка} few {# карточки} many {# карточек} other {# карточки}} · {due} на сегодня",
		"autoUnmarkHint": "Авто-удаление из закладок при 3 верных подряд",
		"studyAllCta": "Учить все ({n})",
		"kpi": {
			"total": "всего",
			"sets": "наборов"
		},
		"markCard": "В закладки",
		"unmarkCard": "Убрать из закладок",
		"markedList": "Закладки",
		"empty": {
			"title": "В закладках пока пусто.",
			"subtitle": "Во время сессии нажми на закладку или клавишу M — карточка попадёт сюда.",
			"back": "В библиотеку наборов"
		},
		"table": {
			"set": "Набор",
			"addedAt": "Добавлено"
		},
		"bulk": {
			"selected": "{n} выбрано",
			"unmark": "Снять отметку",
			"delete": "Удалить",
			"move": "Переместить в набор",
			"cancel": "Отменить"
		},
		"menu": {
			"unmark": "Снять пометку",
			"edit": "Редактировать",
			"move": "Переместить в набор",
			"resetSrs": "Сбросить SRS",
			"delete": "Удалить"
		}
	},
	"editor": {
		"newTitle": "Новая карточка",
		"editTitle": "Редактирование карточки",
		"step1Label": "Выберите тип карточки",
		"step1Hint": "Можно изменить после создания",
		"typeNames": {
			"term-definition": "Термин → Определение",
			"fill-blank": "Пропуск",
			"multiple-choice": "Множественный выбор",
			"audio-term": "Аудио → термин",
			"image-term": "Картинка → термин",
			"term-image": "Термин → картинка"
		},
		"fields": {
			"term": "Термин (лицо)",
			"definition": "Определение (оборот)",
			"blankText": "Текст с пропуском",
			"blankAnswer": "Ответ (что подставляется)",
			"question": "Вопрос",
			"options": "Варианты ответа",
			"ttsText": "Текст для TTS (произношение)",
			"audioTerm": "Ответ (термин)",
			"audioDefinition": "Определение (опц.)",
			"voice": "Голос TTS",
			"frontImage": "Изображение (лицо)",
			"backImage": "Изображение (оборот)",
			"caption": "Подпись / название",
			"captionBack": "Подпись под изображением (опц.)",
			"termText": "Термин (лицо)",
			"hint": "Подсказка (опц.)",
			"tags": "Тэги",
			"citation": "Источник (опц.)",
			"optionPlaceholder": "Вариант {index}"
		},
		"actions": {
			"next": "Далее →",
			"cancel": "Отмена",
			"save": "Сохранить",
			"create": "Создать",
			"mark": "Отметить",
			"resetSrs": "Сбросить SRS"
		},
		"audio": {
			"preview": "Прослушать",
			"regenerate": "Регенерировать",
			"loading": "Генерация..."
		},
		"image": {
			"dropzone": "Перетащи или выбери файл",
			"hint": "PNG/JPG/WebP до 10MB",
			"remove": "Удалить",
			"open": "Открыть",
			"uploading": "Загрузка {percent}%",
			"cancel": "Отменить",
			"errorTooLarge": "Файл больше 10 МБ",
			"errorUnsupported": "Поддерживаются PNG, JPG, WebP, GIF, HEIC",
			"errorNetwork": "Не удалось загрузить — проверь соединение",
			"errorGeneric": "Не удалось загрузить картинку"
		},
		"mcq": {
			"addOption": "Добавить вариант (max 6)",
			"minOptions": "Минимум 2 варианта",
			"correctHint": "Отметь правильный"
		},
		"fillBlank": {
			"insertBlank": "Вставить пропуск",
			"previewLabel": "Предпросмотр"
		},
		"tagsPlaceholder": "Добавь тег и нажми Enter",
		"citationPlaceholder": "Поиск из материала...",
		"toast": {
			"saved": "Сохранено",
			"created": "Карточка создана",
			"invalidFields": "Заполните обязательные поля"
		}
	},
	"rating": {
		"again": "Снова",
		"againHint": "Не помню",
		"hard": "Сложно",
		"hardHint": "Вспомнил с трудом",
		"good": "Хорошо",
		"goodHint": "Вспомнил",
		"easy": "Легко",
		"easyHint": "Знаю точно"
	},
	"types": {
		"termDefinition": "Термин — определение",
		"fillBlank": "Заполни пропуск",
		"multipleChoice": "Выбор ответа",
		"audioTerm": "Аудио → термин",
		"imageTerm": "Изображение → термин",
		"termImage": "Термин → изображение"
	},
	"list": {
		"title": "Все колоды",
		"empty": "Нет карточек",
		"create": "Создать колоду"
	},
	"session": {
		"start": "Начать повторение",
		"resume": "Продолжить",
		"progress": "{current} из {total}",
		"remaining": "{count, plural, one {# карточка} few {# карточки} many {# карточек} other {# карточки}} осталось",
		"finished": "Сессия завершена",
		"noCardsDue": "На сегодня всё повторено"
	},
	"stats": {
		"dueToday": "{count, plural, one {# карточка} few {# карточки} many {# карточек} other {# карточки}} к повторению",
		"newCards": "Новых: {count}",
		"learning": "В изучении: {count}",
		"reviewing": "На повторе: {count}",
		"mastered": "Усвоено: {count}"
	},
	"generation": {
		"starting": "Создаём карточки…",
		"ready": "{count, plural, one {# карточка готова} few {# карточки готовы} many {# карточек готово} other {# карточки готово}}",
		"failed": "Не удалось создать карточки"
	},
	"aiDisclaimer": {
		"message": "Сгенерировано AI. Проверь точность перед использованием.",
		"ack": "Понятно"
	},
	"mobileUx": {
		"filtersLabel": "Фильтры",
		"filtersTitle": "Фильтры карточек",
		"filtersApply": "Применить",
		"filtersReset": "Сбросить",
		"actionsTitle": "Действия",
		"cardActionsTitle": "Действия с карточкой",
		"swipeDelete": "Удалить",
		"refresh": "Обновить",
		"studyCtaShort": "Учить",
		"frontLabel": "Лицо",
		"backLabel": "Оборот",
		"quotaUnlimited": "Без лимита"
	},
	"intro": {
		"title": "Карточки возвращаются сами",
		"body": "Приложение считает, когда вы забудете карточку, и показывает её именно тогда. Тест — разовая проверка, карточки — повторение по расписанию.",
		"bullets": [
			"Ваша оценка ответа задаёт срок следующего показа",
			"Шесть типов: от «термин — определение» до пропусков",
			"Набор собирается из материала, темы или слабого места"
		]
	}
}
